/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getAccountMessageUsage(month) {
    return axios.get(`${this.baseUrl()}/whatsapp_message_usage`, {
      params: { month },
    });
  }

  getMessageUsage(inboxId, month) {
    return axios.get(`${this.url}/${inboxId}/message_usage`, {
      params: { month },
    });
  }

  updateMessageUsageSettings(inboxId, settings) {
    return axios.patch(`${this.url}/${inboxId}/message_usage_settings`, {
      settings,
    });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  getMessageLinks(inboxId) {
    return axios.get(`${this.url}/${inboxId}/message_links`);
  }

  deleteMessageLink(inboxId, code) {
    return axios.delete(`${this.url}/${inboxId}/message_links`, {
      params: { code },
    });
  }

  createMessageLink(inboxId, prefilledMessage) {
    return axios.post(`${this.url}/${inboxId}/message_links`, {
      prefilled_message: prefilledMessage,
    });
  }
}

export default new InboxHealthAPI();
